import { gql } from '@apollo/client';
import { ImageFragment } from '../../fragments/image';

export const QUERY_NOT_FOUND_PAGE = gql`
  query notFoundPage {
    notFoundPage {
      data {
        attributes {
          image {
            data {
              ...ImageFragment
            }
          }
          title
          description
          cta
        }
      }
    }
  }
  ${ImageFragment}
`;
